import { Enum } from "typescript-string-enums";
import fetchWithUuid from "./fetchWithUuid";

export type strexMethod = keyof typeof strexMethods;
export const strexMethods = Enum('create', 'validate');
export type StrexPaymentMethodDeferred = (
  spidId: number,
  sig: string,
  phoneOrPaymentMethodId: string,
  method: strexMethod,
  code?: string,
  price?: number
) => Promise<Response>;

const strexPaymentMethod: StrexPaymentMethodDeferred = (
  spidId: number,
  sig: string,
  phoneOrPaymentMethodId: string,
  method: strexMethod,
  code?: string,
  price?: number
) => {
  const queryUrl: string = `/bestilling/strex/${method}/${spidId}/${phoneOrPaymentMethodId}${
    code ? '/' + code : ''
  }.json${price ? '?price='+price : ''}`;
  return fetchWithUuid(queryUrl, {
    headers: {
      'x-score-spid-sig': sig
    }
  });
};

export default strexPaymentMethod;
